import { useState, useEffect, useCallback } from "react";

import { Invoice } from "../bitmaker/schemas/Billing/Invoice";
import { normalizeInvoice } from "./useInvoices";
import { useApiError } from "./useApiError";

import { BitmakerAPIClient } from "../services/BitmakerApp";

export function useClientInvoices(clientId: string | undefined) {
  const { handleAPIError } = useApiError();

  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [loadingClientInvoices, setLoadingClientInvoices] = useState(false);
  const [fetchClientInvoicesError, setFetchClientInvoicesError] = useState<
    string | null
  >(null);

  const fetchClientInvoices = useCallback(() => {
    if (!clientId) {
      setInvoices([]);
      setFetchClientInvoicesError(null);
      return;
    }

    setLoadingClientInvoices(true);
    setFetchClientInvoicesError(null);

    BitmakerAPIClient.get(
      `/billing/clients/${clientId}/invoices`,
      null,
      (response) => {
        const { isError, message } = handleAPIError(response);

        if (isError) {
          console.error("Error fetching client invoices:", message);
          setFetchClientInvoicesError(
            "Error fetching client invoices. Please try again.",
          );
          setLoadingClientInvoices(false);
          return;
        }

        const data = Array.isArray(response.data)
          ? (response.data as Invoice[])
          : [];

        setInvoices(data.map(normalizeInvoice));
        setLoadingClientInvoices(false);
      },
    );
  }, [clientId, handleAPIError]);

  useEffect(() => {
    fetchClientInvoices();
  }, [fetchClientInvoices]);

  return {
    invoices,
    loadingClientInvoices,
    fetchClientInvoicesError,
    refetchClientInvoices: fetchClientInvoices,
  };
}
